import { Button, Dialog } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

export interface InvalidInvitationDialogProps {
  open: boolean
  /** Acknowledge the dead invite and return to the app underneath. */
  onClose: () => void
}

/**
 * Blocking dialog shown when the user lands with an invite token that no
 * longer resolves — expired, revoked, or already used (CORE-6244). It replaces
 * the former full-page message, which was easy to navigate away from and then
 * impossible to get back to. Like the accept variant of the invitation modal
 * it offers no dismiss affordance; the only way forward is "Go to Buffer",
 * which closes it onto the page the user already landed on.
 */
export const InvalidInvitationDialog = ({
  open,
  onClose,
}: InvalidInvitationDialogProps): JSX.Element => (
  <Dialog open={open}>
    <Dialog.Content size="medium">
      <Dialog.Header>
        <Dialog.Title>This invite isn&apos;t valid anymore</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Dialog.Description>
          This invite link has expired, been revoked, or already been used. Ask
          the admin who invited you to send a new one.
        </Dialog.Description>
      </Dialog.Body>
      <Dialog.Footer>
        <Button variant="primary" onClick={onClose}>
          Go to Buffer
        </Button>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog>
)
